module.exports = __webpack_public_path__ + "img/shangpin.fdc85009.png";